<template>
	<!-- 课题基本信息 -->
	<div class="content">
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<h4 class="header-title mb-3">第一步：课题基本信息</h4>
						<div class="card-newProject">
							<el-form :model="baseInfoForm" :rules="baseInfoFormRules" ref="baseInfoForm" label-width="110px" class="demo-baseInfoForm">
								<el-form-item label="课题名称" prop="name"><el-input v-model="baseInfoForm.name"></el-input></el-form-item>
								<el-form-item label="关键词" prop="keywords">
									<el-tag :key="index" v-for="(tag,index) in baseInfoForm.keywords" closable :disable-transitions="false" @close="handleClose(tag)">{{ tag }}</el-tag>
									<el-input
										class="input-new-tag"
										v-if="inputVisible"
										v-model="inputValue"
										ref="saveTagInput"
										size="small"
										@keyup.enter.native="handleInputConfirm"
										@blur="handleInputConfirm"
									></el-input>
									<el-button v-else class="button-new-tag" size="small" @click="showInput">+ New keywords</el-button>
								</el-form-item>
								<!-- <el-form-item label="课题类别" prop="projectTypeId">
									<el-select v-model="baseInfoForm.projectTypeId" placeholder="请选择">
										<el-option v-for="item in topicTypeOptions" :key="item.id" :label="item.dictName" :value="item.id"></el-option>
									</el-select>
								</el-form-item> -->
								<el-form-item label="所属学段" prop="learningType">
									<el-radio-group v-model="baseInfoForm.learningType">
										<el-radio :label="item.id" v-for="(item, index) in learningTypeList" :key="index">{{ item.label }}</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="所属学科" prop="disciplineId">
									<el-select v-model="baseInfoForm.disciplineId" placeholder="请选择">
										<el-option v-for="item in disciplineOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="研究领域" prop="researchFieId">
									<!-- <el-select v-model="baseInfoForm.researchFieId" placeholder="请选择">
										<el-option v-for="item in researchFieOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
									</el-select> -->
									 <el-cascader v-model="baseInfoForm.researchFieId" :options="researchFieOptions" :props="{label:'name',value:'id',checkStrictly: true }" clearable></el-cascader>
								</el-form-item>
								<el-form-item label="预期成果" prop="expectedResearchResults">
									<el-checkbox-group v-model="baseInfoForm.expectedResearchResults">
										<el-checkbox :label="item.label" v-for="(item, index) in researchResultsList" :key="index">{{ item.label }}</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
								<el-form-item label="预结题时间" prop="expectedClosingTime">
									<!-- <el-date-picker
										v-model="baseInfoForm.expectedClosingTime"
										type="datetime"
										format="yyyy-MM-dd HH:mm"
										value-format="yyyy-MM-dd HH:mm:ss"
										placeholder="预期结题时间"
										:default-value="Date.now()+34128000000"
										:picker-options="pickerOptions"
									></el-date-picker> -->
									<el-date-picker
										v-model="baseInfoForm.expectedClosingTime"
										value-format="yyyy-MM-dd HH:mm:ss"
										:default-value="Date.now()+34128000000"
										:picker-options="pickerOptions"
										type="date"
										placeholder="预期结题时间">
									</el-date-picker>
								</el-form-item>
								<div style="text-align: center;"><el-button type="primary" @click="save">保存并下一步</el-button></div>
							</el-form>
						</div>
					</div>
					<!-- end card-body-->
				</div>
				<!-- end card -->
			</div>
			<!-- end col-->
		</div>
	</div>
</template>

<script>
import { addOrEditTopicsDeclaration, getTopicCateById } from '@/api/after/projectApplication.js';
import { getPlatformInformationData } from '@/api/after/systemManagement.js';
export default {
	props:{
		projectApplicationId:{
			type:String | Number,
			default:''
		},
		topicDetail:{
			type:Object,
			default:null
		}
	},
	data() {
		var validateKeywords = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请添加关键词'));
			} else if (value.length < 3) {
				callback(new Error('关键词至少3个'));
			} else {
				callback();
			}
		};
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < (Date.now() + 34128000000);
				},
			},
			dynamicTags: ['标签一', '标签二', '标签三'],
			inputVisible: false,
			inputValue: '',
			baseInfoForm: {
				projectTypeId: '',
				projectTypeName: '',
				disciplineName: '', //所属学科
				researchFieName: '', //研究领域
				name: '',
				keywords: [],
				learningType: '',
				learningTypeName: '',
				disciplineId: '',
				researchFieId: '',
				expectedResearchResults: [],
				expectedClosingTime: '',
				projectId: '',
			},
			baseInfoFormRules: {
				name: [{ required: true, message: '请输入课题名称', trigger: 'blur' }, { max: 40, message: '长度在40字符以下', trigger: 'blur' }],
				keywords: [{ required: true, validator: validateKeywords, trigger: 'blur' }],
				// projectTypeId: [{ required: true, message: '请选择课题类别', trigger: 'change' }],
				learningType: [{ required: true, message: '请选择学段', trigger: 'change' }],
				disciplineId: [{ required: true, message: '请选择学科', trigger: 'change' }],
				researchFieId: [{ required: true, message: '请选择领域', trigger: 'change' }],
				expectedResearchResults: [{ required: true, message: '请选择研究成果', trigger: 'change' }],
				expectedClosingTime: [{ required: true, message: '请选择结题时间', trigger: 'change' }]
			},
			// 预期研究成果列表
			researchResultsList: [
				{
					value: 0,
					label: '专著'
				},
				{
					value: 1,
					label: '案例'
				},
				{
					value: 2,
					label: '论文'
				},
				{
					value: 3,
					label: '研究报告'
				},
				{
					value: 4,
					label: '教材'
				},
				{
					value: 5,
					label: '工具书'
				},
				{
					value: 6,
					label: '电脑软件'
				},
				{
					value: 7,
					label: '其他'
				}
			],
			// 学段列表
			learningTypeList: [
				{
					id: 0,
					label: '幼儿园'
				},
				{
					id: 1,
					label: '小学'
				},
				{
					id: 2,
					label: '初中'
				},
				{
					id: 3,
					label: '高中'
				},
				{
					id: 4,
					label: '高/中职'
				},
				{
					id: 5,
					label: '其他'
				}
			],
			// 课题类型列表
			topicTypeOptions: [],
			// 学科列表
			disciplineOptions: [],
			researchFieOptions: []
		};
	},
	async created() {
		await this.getTopicCateById();
		await this.getDiscipline();
		await this.getResearchFie();
		if (this.topicDetail) {
			this.baseInfoForm = JSON.parse(JSON.stringify(this.topicDetail))
		}
	},
	methods: {
		// 递归找到研究领域名称
		getResearchFieName(id,data){
			data.forEach(item=>{
				if (item.id == id) {
					this.baseInfoForm.researchFieName = item.name
				}else{
					if (item.children) {
						this.getResearchFieName(id,item.children)
					}
				}
			})
		},
		// 保存
		save() {
			this.$refs.baseInfoForm.validate(valid => {
				if (valid) {
					console.log(this.baseInfoForm);
					let form = JSON.parse(JSON.stringify(this.baseInfoForm));
					// 处理学科
					let disciplineIndex = this.disciplineOptions.findIndex(item => {
						return item.id == form.disciplineId;
					});
					console.log(disciplineIndex);
					form.disciplineName = this.disciplineOptions[disciplineIndex].name;
					//处理项目类型
					// let topicTypeIndex = this.topicTypeOptions.findIndex(item => {
					// 	return item.id == form.projectTypeId;
					// });
					form.projectTypeName = this.topicTypeOptions[0].dictName;
					form.projectTypeId = this.topicTypeOptions[0].id;
					// 处理研究领域数据
					this.getResearchFieName(form.researchFieId[form.researchFieId.length-1],this.researchFieOptions)
					form.researchFieName = this.baseInfoForm.researchFieName
					form.researchFieId = form.researchFieId[form.researchFieId.length-1]
					// 处理预期研究成果
					form.expectedResearchResults = form.expectedResearchResults.join(',');
					// 处理关键词数据
					form.keywords = form.keywords.join(',');
					//处理学段
					let learningTypeIndex = this.learningTypeList.findIndex(item=>{
						return item.id == form.learningType
					})
					form.learningTypeName = this.learningTypeList[learningTypeIndex].label
					// 添加项目id
					form.projectId = this.$route.query.projectId;
					// 添加步骤说明
					form.projectNumber = 1
					
					//如果是回显数据,需要处理数据
					if (form.coreMember) {
						form.coreMember = form.coreMember.join(',')
					}
					// 如果是上一步回到这里需要添加id数据
					if (this.projectApplicationId) {
						form.id = this.projectApplicationId
					}
					console.log('处理后的数据', form);
					this.addOrEditTopicsDeclaration(form);
				}
			});
		},
		// 添加或修改课题申报
		async addOrEditTopicsDeclaration(params) {
			const res = await addOrEditTopicsDeclaration(params);
			if (res.code == 200) {
				console.log('添加课题申报', res);
				this.$message.success('添加课题成功！')
				this.$emit('finish', res.data);
				// this.$message({
				// 	type: 'success',
				// 	message: '添加课题成功！',
				// 	duration:1500,
				// 	onClose: () => {
				// 		this.$emit('finish', res.data);
				// 	}
				// });
			}else{
				this.$message.error(res.data)
			}
		},
		// 获取课题类别
		async getTopicCateById() {
			const res = await getTopicCateById(this.$route.query.projectId);
			if (res.code == 200) {
				console.log('更具ID获取课题类别', res);
				this.topicTypeOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取学科
		async getDiscipline() {
			const res = await getPlatformInformationData(8);
			if (res.code == 200) {
				console.log('学科', res);
				this.disciplineOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取研究领域
		async getResearchFie() {
			const res = await getPlatformInformationData(6);
			if (res.code == 200) {
				console.log('研究领域', res);
				this.researchFieOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		handleClose(tag) {
			this.baseInfoForm.keywords.splice(this.baseInfoForm.keywords.indexOf(tag), 1);
		},

		showInput() {
			this.inputVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		},
		// 添加关键词
		handleInputConfirm() {
			let inputValue = this.inputValue;
			if (inputValue) {
				this.baseInfoForm.keywords.push(inputValue);
			}
			this.inputVisible = false;
			this.inputValue = '';
		}
	}
};
</script>

<style scoped>
.el-tag + .el-tag {
	margin-left: 10px;
}
.button-new-tag {
	margin-left: 10px;
	height: 32px;
	line-height: 30px;
	padding-top: 0;
	padding-bottom: 0;
}
.input-new-tag {
	width: 90px;
	margin-left: 10px;
	vertical-align: bottom;
}
</style>
